/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisFileError = produce(function (draft, action) {
  var secondaryAnalysisId = action.payload.secondaryAnalysisId;
  draft[secondaryAnalysisId].files.loading = false;
  draft[secondaryAnalysisId].files.error = action.payload.error;
});
export default secondaryAnalysisFileError;